export default __webpack_public_path__ + "static/media/katika_landing_logo.4fe57a8d.png";